import * as React from 'react';

export type Props = Omit<React.ComponentPropsWithRef<'div'>, 'children'> & {
  children: (el: HTMLDivElement) => React.ReactNode;
};

const Area = React.forwardRef<HTMLDivElement, Props>((props) => {
  const { children, ...rest } = props;
  const ref = React.useRef<HTMLDivElement>(null);
  const [el, setEl] = React.useState<HTMLDivElement>();
  React.useEffect(() => {
    setEl(ref.current!);
  }, []);
  console.log('Area', { el });
  return (
    <div
      ref={ref}
      style={{ border: '1px solid', borderRadius: '4px', width: '100%', height: '300px', marginBottom: '1rem' }}
      {...rest}
    >
      {el && children(el)}
    </div>
  );
});

export default React.memo(Area);
